import { AboutFourData } from "@/data";
import React from "react";
import Img from "./img";
import aboutShape from "@/images/shape/about-shape.png";

const AboutFour = () => {
  const { blockTitle } = AboutFourData;
  const { title, text1, text2 } = blockTitle;
  function createMarkup() {
    return { __html: title };
  }
  return (
    <section className="about_style_3_area section_padding">
      <div className="container">
        <div className="row">
          <div className="col-md-4 col-sm-6">
            <div className="about_image_box"></div>
          </div>
          <div className="col-md-3 col-sm-6">
            <div className="about_image_box about_image_box2"></div>
          </div>
          <div className="col-md-5 col-sm-6">
            <div className="about_image_box about_image_box3"></div>
          </div>

          <div className="col-md-4 col-sm-6">
            <div className="about_style_3_details">
              <h2>Curiamo il tuo business in ogni sua sfumatura a 360 gradi.</h2>
            </div>
          </div>
          <div className="col-md-4 col-sm-6">
            <div className="about_style_3_details">
              <div className="about_us_shape">
                <Img src={aboutShape} alt="about shape" className="img-fluid" />
              </div>
                <p>Rouge Multiservice nasce nel 2021 dopo un’esperienza lavorativa ventennale nel campo dei servizi di pulizia: un'azienda giovane, al passo coi tempi e con le nuove tecnologie formata da professionisti di provata capacità. </p>
            </div>
          </div>

          <div className="col-md-4 col-sm-6">
            <div className="about_style_3_details">
              <p>Il rispetto dell’ambiente e l’ecologia sono i valori portati avanti dai nostri operatori esperti, con formazione specifica, garantiti da un contratto regolare. La qualità del servizio è affidata ad un unico referente che garantisce flessibilità per affrontare le necessità del cliente.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutFour;
